import { useRuntimeConfig } from '#imports'
import { ref } from 'vue'

import { useAuthStore } from '@backmarket/nuxt-layer-oauth/useAuthStore'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

import { buildMilitaryDiscountUrl } from './MilitaryDiscountCTA.utils'

export function useMilitaryDiscountUrl() {
  const url = ref<ReturnType<typeof buildMilitaryDiscountUrl>>()
  const error = ref()

  const authStore = useAuthStore()
  const logger = useLogger()

  const { SHEER_ID_MILITARY_DISCOUNT_URL } = useRuntimeConfig().public

  try {
    url.value = buildMilitaryDiscountUrl({
      authenticated: authStore.authenticated,
      baseSheerIdUrl: SHEER_ID_MILITARY_DISCOUNT_URL,
      encryptedUserId: authStore.encryptedUserId,
    })
  } catch (err) {
    logger.error('[CONTENT] error when building military discount url', {
      error: err as Error,
    })
    error.value = err
  }

  return { url, error }
}
